import React from 'react';
import './org-avatar.scss';

// Avatar colors matching Dream palette
const AVATAR_COLORS = [
  '#086788', // Dark Blue
  '#0B96BB', // Light Blue
  '#59ADA2', // Light Green
  '#374562', // Performa Black
  '#7851A9', // Royal Purple
  '#4B0082', // Dark Purple
  '#881D1B', // Dark Red
  '#C8A2C8', // Lilac
  '#FFD004', // Dream Yellow
  '#F67E7D', // Light Red
];

// Generate consistent color from name
const getAvatarColor = (name: string): string => {
  if (!name) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

// Calculate if text should be white or dark based on background
const getTextColor = (bgColor: string): string => {
  // Convert hex to RGB
  const hex = bgColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.5 ? '#000D26' : '#FFFFFF';
};

interface OrgAvatarProps {
  /** Organization image URL */
  imageUrl?: string;
  /** Organization name for alt text and placeholder letter */
  orgName: string;
  /** Optional size override (defaults to 32px) */
  size?: number;
}

const OrgAvatar: React.FC<OrgAvatarProps> = ({
  imageUrl,
  orgName,
  size = 32,
}) => {
  const bgColor = getAvatarColor(orgName);
  const textColor = getTextColor(bgColor);

  return (
    <>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={`${orgName} logo`}
          className='org-avatar-image'
          style={
            size !== 32
              ? { width: `${size}px`, height: `${size}px` }
              : undefined
          }
        />
      ) : (
        <div
          className='org-avatar-placeholder'
          style={{
            width: `${size}px`,
            height: `${size}px`,
            borderRadius: `${size}px`,
            backgroundColor: bgColor,
            color: textColor,
          }}
        >
          <span>{orgName?.charAt(0).toUpperCase() || '?'}</span>
        </div>
      )}
    </>
  );
};

export default OrgAvatar;
